import React from 'react';
import { IconProps } from '.';

const SvgCancel = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Zm-4.834 7.227A9.462 9.462 0 0 1 12 21.5 9.5 9.5 0 0 1 2.5 12c0-2.353.856-4.507 2.273-6.166l13.393 13.393Zm1.061-1.06L5.834 4.772A9.463 9.463 0 0 1 12 2.5a9.5 9.5 0 0 1 9.5 9.5 9.463 9.463 0 0 1-2.273 6.166Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCancel;
